import Role from 'types/Role';

export const getToken = (): string | null => window.localStorage.getItem('jwt');

export const getRole = (): Role | null => {
  const role = window.localStorage.getItem('role');
  if (role) {
    return JSON.parse(role) as Role;
  }
  return null;
};

export const setToken = (token: string): void =>
  window.localStorage.setItem('jwt', token);

export const setRole = (role: Role): void =>
  window.localStorage.setItem('role', JSON.stringify(role));

export const setDomain = (domain: string): void =>
  window.localStorage.setItem('domain', domain);

export const getDomain = (): string | null =>
  window.localStorage.getItem('domain');

export const isAuthenticated = (): boolean => !!getRole() && !!getToken();

export const logout = (): void => window.localStorage.clear();
